import React, { useEffect } from "react";
import "./App.css";
import MainRoutesComp from "./routes/routes";
import "bootstrap/dist/css/bootstrap.min.css";
import { EventEmitter } from "events";
import BhashiniLoader from "./utils/BhashiniLoader";
import { useLocation } from "react-router-dom";

export const event = new EventEmitter();

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  React.useEffect(() => {
    const handleLogout = () => {
      localStorage.clear();
      window.location.href = "/";
    };
    event.on("logout", handleLogout);
    return () => {
      event.off("logout", handleLogout);
    };
  }, []);
   useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get("clearStorage") === "true") {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      // remove query param from URL without reload
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}, []);

  return (
    <>
      <BhashiniLoader />
      <MainRoutesComp />
    </>
  );
}

export default App;
